import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Refer from "@/pages/Refer";
import Resources from "@/pages/Resources";
import Login from "@/pages/Login";
import Academy from "@/pages/Academy";
import AdminDashboard from "@/pages/AdminDashboard";
import FamilyPortal from "@/pages/FamilyPortal";
import TimeClock from "@/pages/TimeClock";
import AdminClock from "@/pages/AdminClock";
import EmployeePortal from "@/pages/EmployeePortal";
import ScrollToTop from "@/components/ScrollToTop";

// Stable role arrays — module-level constants avoid new array identities on every render
const ROLES_EMPLOYEE_ADMIN = ["employee", "admin"];
const ROLES_FAMILY_ADMIN = ["family", "admin"];
const ROLES_ADMIN_ONLY = ["admin"];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/refer" element={<Refer />} />
              <Route path="/employee-portal" element={<EmployeePortal />} />
            </Route>

            <Route path="/login" element={<Login />} />

            <Route path="/academy/*" element={
              <ProtectedRoute roles={ROLES_EMPLOYEE_ADMIN}><Academy /></ProtectedRoute>
            }/>
            <Route path="/family/*" element={
              <ProtectedRoute roles={ROLES_FAMILY_ADMIN}><FamilyPortal /></ProtectedRoute>
            }/>
            <Route path="/clock" element={
              <ProtectedRoute roles={ROLES_EMPLOYEE_ADMIN}><TimeClock /></ProtectedRoute>
            }/>
            <Route path="/admin/clock" element={
              <ProtectedRoute roles={ROLES_ADMIN_ONLY}><AdminClock /></ProtectedRoute>
            }/>
            <Route path="/admin/*" element={
              <ProtectedRoute roles={ROLES_ADMIN_ONLY}><AdminDashboard /></ProtectedRoute>
            }/>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
